// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__pUXb9"};